import * as e from '../../constants/events';
import { MAINALTERNATIVE } from '../../constants/selectors';

const DEFAULT_LOCALE = 'de_DE';
const DEFAULT_APP_DOMAIN_ID = '1';

export const pushQvDisplayedEvent = data => {
  dataLayer.push({
    variation: 'a',
    productSimpleSKU: data.smp,
    productConfigSKU: data.cfg,
    name: data.name,
    price: data.price.sellPrice,
    size: data.height,
    event: e.STANDARD
  });
};

export const height = selectedMvcAttributes => {
  if (!selectedMvcAttributes) {
    return 320;
  }
  switch (Object.keys(selectedMvcAttributes).length) {
    case 2:
      return 370;
    case 3:
      return 430;
    default:
      return 320;
  }
};

const getLocale = () => (dataLayer ? dataLayer[0].language : DEFAULT_LOCALE);

const getAppDomainId = () =>
  window.location.origin.indexOf('fashionforhome') > -1
    ? 8
    : appDomainId[getLocale()];

export const appDomainProvider = () => {
  const locale = getLocale();
  const appDomain = getAppDomainId();
  return { appDomain, lngcode: locale };
};

export const getDataOptions = () => ({
  appDomainId: getAppDomainId(),
  language: getLocale(),
  url: '/shop-app/quick-view/?'
});

const appDomainId = {
  de_DE: 1,
  fr_FR: 2,
  nl_NL: 3,
  de_AT: 4,
  de_CH: 5,
  fr_CH: 5,
  fr_BE: 6,
  nl_BE: 6,
  it_IT: 7
};

const getAltDIVKey = appDomain => (appDomain === 8 ? 'de_DE_FFH' : getLocale());

const altDIV1 = {
  de_DE: `${MAINALTERNATIVE}`,
  fr_FR: `${MAINALTERNATIVE}_FR`,
  nl_NL: `${MAINALTERNATIVE}_NL`,
  de_AT: `${MAINALTERNATIVE}_AT`,
  de_CH: `${MAINALTERNATIVE}_CH`,
  fr_CH: `${MAINALTERNATIVE}_CH`,
  fr_BE: `${MAINALTERNATIVE}_BE`,
  nl_BE: `${MAINALTERNATIVE}_BE`,
  it_IT: 'dy_IT_Global_Ribbon',
  de_DE_FFH: `${MAINALTERNATIVE}_FFH`
};

const altDIV2 = {
  de_DE: `${MAINALTERNATIVE}`,
  fr_FR: `dy_FR_Global_Ribbon`,
  nl_NL: `${MAINALTERNATIVE}_NL`,
  de_AT: `${MAINALTERNATIVE}_AT`,
  de_CH: `${MAINALTERNATIVE}_CH`,
  fr_CH: `${MAINALTERNATIVE}_ch_FR`,
  fr_BE: `${MAINALTERNATIVE}_BE`,
  nl_BE: `${MAINALTERNATIVE}_BE`,
  it_IT: 'dy_IT_Global_Ribbon',
  de_DE_FFH: `${MAINALTERNATIVE}_FFH`
};

export const alternativeDIVprovider = () => {
  const { appDomain } = appDomainProvider();
  const altDIVKey = getAltDIVKey(appDomain);

  return altDIV1[altDIVKey];
};

export const alternativeDIV2Provider = () => {
  const { appDomain } = appDomainProvider();
  const altDIVKey = getAltDIVKey(appDomain);

  return altDIV2[altDIVKey];
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/functions/helpers/helpers.js
 **/